import { useEffect, useRef } from 'react';

export const useAppVisibility = () => {
  const isAppVisibleRef = useRef<boolean>(true);

  useEffect(() => {
    const updateVisibility = () => {
      isAppVisibleRef.current = document.visibilityState === 'visible';
    };

    updateVisibility();

    document.addEventListener('visibilitychange', updateVisibility);

    return () => {
      document.removeEventListener('visibilitychange', updateVisibility);
    };
  }, []);

  return isAppVisibleRef;
};
